import { useState, useEffect } from 'react';
import isLandscape from '../utils/isLandscape';
import { ScreenOrientation } from '../enums';

const useScreenOrientation = (): ScreenOrientation => {
    const [orientation, setOrientation] = useState<ScreenOrientation>(
        isLandscape() ? ScreenOrientation.LANDSCAPE : ScreenOrientation.PORTRAIT,
    );

    const onScreenOrientationChange = (): void => {
        if (
            window.screen.orientation.type === 'portrait-primary' ||
            window.screen.orientation.type === 'portrait-secondary'
        ) {
            setOrientation(ScreenOrientation.PORTRAIT);
        } else {
            setOrientation(ScreenOrientation.LANDSCAPE);
        }
    };

    const onWindowOrientationChange = (): void => {
        if (window.orientation === 0) {
            setOrientation(ScreenOrientation.PORTRAIT);
        } else {
            setOrientation(ScreenOrientation.LANDSCAPE);
        }
    };

    const mediaQueryListener = (e: MediaQueryListEvent): void => {
        setOrientation(e.matches ? ScreenOrientation.LANDSCAPE : ScreenOrientation.PORTRAIT);
    };

    useEffect(() => {
        const mediaQueryList = window.matchMedia('(orientation: landscape)');

        if (window.screen.orientation && 'onchange' in window.screen.orientation) {
            // on most browsers( Chrome on OSX, Chrome for Android...)  except Safari, and Chrome on iOS
            window.screen.orientation.addEventListener('change', onScreenOrientationChange);
        } else if ('onorientationchange' in window) {
            // deprecated but work on Safari on iOS, Chrome on iOS-->90 for landscape, 0 for portrait
            window.addEventListener('orientationchange', onWindowOrientationChange);
        } else {
            // Safari on OSX
            mediaQueryList.addListener(mediaQueryListener);
        }

        return () => {
            if (window.screen.orientation && 'onchange' in window.screen.orientation) {
                window.screen.orientation.removeEventListener('change', onScreenOrientationChange);
            } else if ('onorientationchange' in window) {
                window.removeEventListener('orientationchange', onWindowOrientationChange);
            } else {
                mediaQueryList.removeListener(mediaQueryListener);
            }
        };
    }, []);

    return orientation;
};

export default useScreenOrientation;
